import React from "react";
import QTextBox from "../../../../common/components/QTextBox";
import {ResponseInterface} from "../../../../interfaces/ResponseInterface";
import {config} from "../../../../config";
import {Col, Row} from "reactstrap";
import {Formik} from "formik";
import QButton from "../../../../common/components/QButton";
import {useDispatch} from "react-redux";
import {setToast} from "../../../../app/rootReducer";
import SetupApi from "../../../../common/api/functions/Setup";
import {SetupInterface} from "../../../../interfaces/private/SetupInterface";

interface Props {
    model: SetupInterface,
    setOpen: Function,
    setLoadingFunc: Function,
    setSetup: Function,
}

const BodyShippingInformationComponent: React.FC<Props> = ({model, setOpen, setLoadingFunc, setSetup}) => {
    const dispatch = useDispatch();

    return (
        <React.Fragment>
            <Formik
                initialValues={{...model}}
                onSubmit={(values: any) => {
                    SetupApi.update(values).then(async (response: ResponseInterface | any) => {
                        if (response.status === config.STATUS_CODE.OK) {
                            await setOpen(false);
                            await setLoadingFunc(true);
                            await dispatch(setToast({
                                message: "Update success",
                                type: config.TOAST_TYPE.SUCCESS
                            }))
                        }
                    })
                }}
            >
                {formik => {

                    return (
                        <React.Fragment>
                            <Row>
                                <Col>
                                    <QTextBox
                                        label={'Username'}
                                        value={formik.values.gls_username}
                                        onChange={(value: string) => {
                                            formik.setFieldValue('gls_username', value)
                                        }}
                                    />
                                     <QTextBox
                                        type={'password'}
                                        label={'Password'}
                                        value={formik.values.gls_password}
                                        onChange={(value: string) => {
                                            formik.setFieldValue('gls_password', value)
                                        }}
                                    />
                                     <QTextBox
                                        label={'Contact Id'}
                                        value={formik.values.gls_contact_id}
                                        onChange={(value: string) => {
                                            formik.setFieldValue('gls_contact_id', value)
                                        }}
                                    />
                                     <QTextBox
                                        label={'Customer Id'}
                                        value={formik.values.gls_customer_id}
                                        onChange={(value: string) => {
                                            formik.setFieldValue('gls_customer_id', value)
                                        }}
                                    />
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <div className={'d-flex justify-content-end gap-2'}>
                                        <QButton
                                            type={'default'}
                                            onClick={() => {
                                                setOpen(false)
                                            }}
                                            content={'Cancel'}
                                        />

                                        <QButton
                                            type={'primary'}
                                            onClick={() => {
                                                formik.handleSubmit()
                                            }}
                                            content={'Submit'}
                                        />

                                    </div>
                                </Col>
                            </Row>
                        </React.Fragment>
                    )
                }}
            </Formik>
        </React.Fragment>
    )
}

export default BodyShippingInformationComponent
